import React, { useEffect, useState } from 'react';

import t from 'utils/translate';
import LabelWithInfo from 'modules/shared/components/label-with-info';
import Preloader from 'modules/shared/components/preloader';
import {
    loadLocalizedCountryNames,
    selectLocalizedCountriesNames,
    selectLanguageSelectorDataIsLoading,
} from 'modules/settings/stores/user-settings-slice-handler';
import { useSelector } from 'react-redux';
import SelectInput from 'modules/shared/components/select-input';
import { MenuItem, Select } from '@mui/material';
import LayoutManager from 'utils/layout-manager';
import classNames from 'classnames';

function SectionLanguageSelector() {
    useEffect(() => {
        loadLocalizedCountryNames();
    }, []);

    const localizedCountriesNames = useSelector(selectLocalizedCountriesNames);
    const languagesList = Object.keys(localizedCountriesNames);
    const dataIsLoading = useSelector(selectLanguageSelectorDataIsLoading);
    const [languageIsUpdating, setLanguageIsUpdating] = useState(false);
    const handleLanguageChange = (e) => {
        setLanguageIsUpdating(true);

        LayoutManager.changeLanguage(e.target.value).then(() => {
            setLanguageIsUpdating(false);
        });
    };

    return (
        <div className={classNames('settings-section', 'language-selector-container')}>
            <div className="settings-section-title">
                <LabelWithInfo text={t('settings_interface_language_title')} />
                <div className="strike" />
            </div>
            <div className={'section-content'}>
                <div className={'section-row language-selector-label'}>
                    <LabelWithInfo text={t('settings_language_title')} info={t('settings_language_tooltip')} />
                    {dataIsLoading || languageIsUpdating ? (
                        <Preloader />
                    ) : (
                        <>
                            <div className={'i18n-icon'}>
                                <span className={'stw-i18n'}></span>
                            </div>
                            <SelectInput
                                value={languagesList.length > 0 ? LayoutManager.getLanguage() : ''}
                                onChange={handleLanguageChange}
                                className="info-field-dropdown"
                                data-test-id="language-selector"
                            >
                                {languagesList.map((languageCode) => (
                                    <MenuItem key={languageCode} value={languageCode}>
                                        {localizedCountriesNames[languageCode]}
                                    </MenuItem>
                                ))}
                            </SelectInput>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SectionLanguageSelector;
